export default __webpack_public_path__ + "media/images/landing-32-550x420-be2578a188aa1fc478faaae3e0c6f77a.jpg";